import { ERROR_RED_600, GRAY_900, WHITE } from 'constants/styling/theme'

import Badge from '@mui/material/Badge'
import { ChatBubbleOutline } from '@mui/icons-material'
import { FC } from 'react'
import IconButton from '@mui/material/IconButton'
import { requestNotificationPermission } from '../helpers/useBrowserNotifications'
import { useChatWidget } from '../ChatWidget.context'
import { useTranslation } from 'react-i18next'

interface Props {
  /** Total unread messages across conversations, shown as a badge. */
  unreadTotal?: number
}

/** Floating launcher button that opens the chat widget (Figma bottom-right action button). */
export const ChatLauncherButton: FC<Props> = ({ unreadTotal = 0 }) => {
  const { t } = useTranslation(['chat'])
  const { openReduced } = useChatWidget()

  // Opening the widget is the first user gesture we get, and browsers only show the permission prompt
  // from inside one.
  const handleOpen = () => {
    requestNotificationPermission('launcher')
    openReduced()
  }

  return (
    <Badge
      color="error"
      badgeContent={unreadTotal}
      overlap="circular"
      max={99}
      data-chat-launcher
      slotProps={{ badge: { 'aria-hidden': true } }}
      sx={{
        '& .MuiBadge-badge': {
          minWidth: '2.4rem',
          height: '2.4rem',
          padding: '0 0.6rem',
          borderRadius: '1.2rem',
          border: `0.2rem solid ${WHITE}`,
          backgroundColor: ERROR_RED_600,
          color: WHITE,
          fontSize: '1.3rem',
          fontWeight: 700,
          lineHeight: 1,
        },
      }}
    >

      <IconButton
        aria-label={unreadTotal > 0 ? t('chat:actions.open_chat_unread', { count: unreadTotal }) : t('chat:actions.open_chat')}
        onClick={handleOpen}
        sx={{
          width: '4.8rem',
          height: '4.8rem',
          backgroundColor: GRAY_900,
          color: WHITE,
          boxShadow: '0 4px 16px rgba(0,0,0,0.24)',
          '&:hover': { backgroundColor: GRAY_900, opacity: 0.92 },
        }}
      >
        <ChatBubbleOutline sx={{ fontSize: '2.2rem' }} />
      </IconButton>

    </Badge>
  )
}
